export function getId(m: { id: string | null }): string {
	return m.id!;
}
